
export default class InternationalMapBlock {
  constructor(rootElement) {
    this.rootElement = rootElement;

    this.markers = this.rootElement.querySelectorAll('[data-name=marker]');
    this.countries = this.rootElement.querySelectorAll('[data-name=country]');

    this.internationalContentLinks = this.rootElement.querySelectorAll('.international-map-block__link');
    this.mapLinks = this.rootElement.querySelectorAll('.int_map_link');

    // Add links to the map
    this.addLinksToMap();

    // Add event listeners for map markers and buttons(data-name="marker").
    if(this.markers.length > 0) {
      this.markers.forEach(marker => {
        marker.addEventListener('mouseenter', (event) => this.focusMapArea(event, marker.dataset.area));
        marker.addEventListener('mouseleave', (event) => this.unfocusMapArea(event, marker.dataset.area));
      });
    }
  }

  // Add links to the map items
  addLinksToMap() {
    if(this.internationalContentLinks.length && this.mapLinks.length) {
      this.internationalContentLinks.forEach(contentLink => {
        const url = contentLink.href;
        const mapArea = contentLink.dataset.area;

        // Should be 2 - the map marker and map area/country
        const mapLinksToMake = this.rootElement.querySelectorAll('[data-int-map-link='+mapArea+']');

        if(mapLinksToMake.length) {
          mapLinksToMake.forEach(linkToMake => {
            linkToMake.setAttribute('xlink:href', url);
          });
        }

      });
    }
  }

  // When map marker/related button is hovered highlight map area
  focusMapArea(event, markerName = null) {
    const mapArea = this.rootElement.querySelector('#' + markerName);
    const mapAreaMarker = this.rootElement.querySelector('#marker-' + markerName);
    if(mapArea) {
      mapArea.classList.add('--hovered');
    }
    if(mapAreaMarker) {
      mapAreaMarker.classList.add('--hovered');
    }
  }

  // Remove highlight when mouse off marker/related button
  unfocusMapArea(event, markerName = null) {
    const mapArea = this.rootElement.querySelector('#' + markerName);
    const mapAreaMarker = this.rootElement.querySelector('#marker-' + markerName);
    if(mapArea) {
      mapArea.classList.remove('--hovered');
    }
    if(mapAreaMarker) {
      mapAreaMarker.classList.remove('--hovered');
    }
  }
}
